/**
 * ID18 — EVER TV 외부 서비스 설정 FE 타입.
 * 관리자가 GA(측정ID)·외부 스크립트를 상점별(기준/영문/중문/일문)로 등록·제어하면
 * storefront 가 전역/페이지별로 주입한다. (be-catalog ID18 계약 — 도착 시 정합.)
 */

/** 상점 스코프. ALL=전 상점 공통, BASE=기준(국문), EN/CN/JP=각 외국어 상점. */
export type StoreScope = 'ALL' | 'BASE' | 'EN' | 'CN' | 'JP';

export const STORE_SCOPES: ReadonlyArray<StoreScope> = ['ALL', 'BASE', 'EN', 'CN', 'JP'];

/** 운영자 탭으로 노출하는 상점 스코프(ALL 은 별도 토글/필터로 다룸). */
export const STORE_SCOPE_TABS: ReadonlyArray<StoreScope> = ['BASE', 'EN', 'CN', 'JP'];

export const STORE_SCOPE_LABELS: Record<StoreScope, string> = {
  ALL: '전체',
  BASE: '기준',
  EN: '영문',
  CN: '중문',
  JP: '일문',
};

/** 스크립트 분류. GA=Google Analytics(measurementId), 나머지는 scriptContent. */
export type ExternalScriptCategory = 'GA' | 'PIXEL' | 'EMBED' | 'CUSTOM';

export const EXTERNAL_SCRIPT_CATEGORIES: ReadonlyArray<ExternalScriptCategory> = [
  'GA',
  'PIXEL',
  'EMBED',
  'CUSTOM',
];

export const EXTERNAL_SCRIPT_CATEGORY_LABELS: Record<ExternalScriptCategory, string> = {
  GA: 'Google Analytics',
  PIXEL: '픽셀/태그',
  EMBED: '임베드',
  CUSTOM: '커스텀',
};

/** 주입 위치. */
export type ScriptPlacement = 'HEAD' | 'BODY_TOP' | 'BODY_BOTTOM';

export const SCRIPT_PLACEMENTS: ReadonlyArray<ScriptPlacement> = ['HEAD', 'BODY_TOP', 'BODY_BOTTOM'];

export const SCRIPT_PLACEMENT_LABELS: Record<ScriptPlacement, string> = {
  HEAD: '<head>',
  BODY_TOP: '<body> 상단',
  BODY_BOTTOM: '<body> 하단',
};

/** 노출 상태. ON=프로덕션 노출, OFF=비노출, TEST=관리자/비프로덕션만. */
export type ExternalScriptStatus = 'ON' | 'OFF' | 'TEST';

export const EXTERNAL_SCRIPT_STATUSES: ReadonlyArray<ExternalScriptStatus> = ['ON', 'OFF', 'TEST'];

export const EXTERNAL_SCRIPT_STATUS_LABELS: Record<ExternalScriptStatus, string> = {
  ON: '노출',
  OFF: '비노출',
  TEST: '테스트',
};

/** GET /admin/v1/ever-tv/external-services 항목 (ExternalServiceScriptResponse). */
export interface ExternalServiceScript {
  id: string;
  storeScope: StoreScope;
  category: ExternalScriptCategory;
  serviceName: string;
  /** GA 측정 ID (예: G-XXXXXXX). GA 가 아니면 null. */
  measurementId: string | null;
  /** EMBED/CUSTOM/PIXEL 스크립트 원문. GA 면 null. */
  scriptContent: string | null;
  placement: ScriptPlacement;
  status: ExternalScriptStatus;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

/** POST/PUT body (ExternalServiceScriptRequest). */
export interface ExternalServiceScriptPayload {
  storeScope: StoreScope;
  category: ExternalScriptCategory;
  serviceName: string;
  measurementId?: string | null;
  scriptContent?: string | null;
  placement: ScriptPlacement;
  status: ExternalScriptStatus;
  sortOrder: number;
}
